import {Fragment as _Fragment, jsx as _jsx, jsxs as _jsxs} from "react/jsx-runtime";
export let lastModified = undefined;
export let frontmatter = {
  "title": "Turborepo 1.11",
  "description": "Turborepo 1.11 sets the Rust-based foundation for the future of Turborepo.",
  "date": "2023/12/05",
  "tag": "web development"
};
export let structuredData = {
  "contents": [{
    "heading": "",
    "content": "Turborepo 1.11 completes our migration to Rust and ships several developer experience improvements:"
  }, {
    "heading": "",
    "content": "Our new Rust-based foundation: We've finished the port from Go to lay the groundwork for better performance, improved stability, and new features."
  }, {
    "heading": "",
    "content": "Group logs for improved readability: You can now specify --log-order=grouped to organize your logs into distinct sections separated by tasks."
  }, {
    "heading": "",
    "content": "Updated examples: Start with an example for Next.js, Svelte, Remix, Nuxt, and more."
  }, {
    "heading": "",
    "content": "Update today by running npx @turbo/codemod migrate."
  }, {
    "heading": "unlocking-the-future-of-turbo-with-rust",
    "content": "As we wrote about in our blog post about the migration, we're excited to start seeing the benefits of our porting effort for Turborepo users. Rust has allowed us to surface more complexity in our code so we're able to create a better experience in your codebase in several ways:"
  }, {
    "heading": "unlocking-the-future-of-turbo-with-rust",
    "content": "We've noticed a slight performance improvement right away for some use cases, even without doing much performance tuning in our code yet. We look forward to diving deeper into making turbo even faster soon."
  }, {
    "heading": "unlocking-the-future-of-turbo-with-rust",
    "content": "We were able to move incidental behaviors of globbing, paths, and encoding support to tested and supported behavior, giving us better confidence that we're handling your configuration as expected. Going forward, we'll be able to build features like validation and automatic bug-fixing codemods into Turborepo for better stability."
  }, {
    "heading": "unlocking-the-future-of-turbo-with-rust",
    "content": "We've quickly iterated on enhancing error messages in your monorepo as a feature for next release, giving you critical information for find the source of misconfigurations."
  }, {
    "heading": "unlocking-the-future-of-turbo-with-rust",
    "content": "We've been able to catch possible platform-related bugs much sooner, as Rust forces us to think about the differences between platforms and environments much more closely than Go. This deepened reliability removes an entire category of possible bugs from your repository."
  }, {
    "heading": "unlocking-the-future-of-turbo-with-rust",
    "content": "If you find any problems that you believe are related to the new Rust codepath, you can opt back to the Go codepath using the --go-fallback flag and report an issue on GitHub."
  }, {
    "heading": "group-logs-for-improved-readability",
    "content": "To make it easier to review your task logs, we've introduced the --log-order flag to output all logs from a task after it finishes rather than as it writes. This results in logs that are separated per-task, improving readability on a specific task's logs."
  }, {
    "heading": "group-logs-for-improved-readability",
    "content": "Enable this behavior using --log-order=grouped. Check out the documentation to learn more"
  }, {
    "heading": "updated-examples",
    "content": "Our repository contains an examples directory with starter monorepos for your projects."
  }, {
    "heading": "updated-examples",
    "content": "To get started with an example, run:"
  }, {
    "heading": "updated-examples",
    "content": "We're putting a renewed effort towards ensuring our examples are kept up-to-date. Additionally, we've re-architected our examples to advocate for best practices in monorepos. For example:"
  }, {
    "heading": "updated-examples",
    "content": "In-editor go-to-definition across packages"
  }, {
    "heading": "updated-examples",
    "content": "Dependencies updated to latest versions"
  }, {
    "heading": "updated-examples",
    "content": "Tooling like ESLint, Prettier, jest, and vitest pre-configured"
  }, {
    "heading": "updated-examples",
    "content": "Hot-reloading across packages"
  }, {
    "heading": "updated-examples",
    "content": "Use an example to get started, or browse the code directly for more."
  }, {
    "heading": "community",
    "content": "Since releasing Turborepo 1.10 we've seen incredible adoption and community growth:"
  }, {
    "heading": "community",
    "content": "23.6k+ GitHub Stars"
  }, {
    "heading": "community",
    "content": "1.8M+ weekly NPM downloads"
  }, {
    "heading": "community",
    "content": "206 years of compute time saved through Remote Caching on Vercel"
  }, {
    "heading": "community",
    "content": "Turborepo is the result of the combined work of all of its contributors, including our core team."
  }, {
    "heading": "community",
    "content": "Thank you for your continued support, feedback, and collaboration to make Turborepo your build tool of choice."
  }],
  "headings": [{
    "id": "unlocking-the-future-of-turbo-with-rust",
    "content": "Unlocking the future of turbo with Rust"
  }, {
    "id": "group-logs-for-improved-readability",
    "content": "Group logs for improved readability"
  }, {
    "id": "updated-examples",
    "content": "Updated examples"
  }, {
    "id": "community",
    "content": "Community"
  }]
};
import {Authors} from '#components/authors';
import {ThemeAwareImage} from '#components/theme-aware-image';
import {Date} from '#components/blog/date';
export const toc = [{
  depth: 2,
  url: "#unlocking-the-future-of-turbo-with-rust",
  title: _jsxs(_Fragment, {
    children: ["Unlocking the future of ", _jsx("code", {
      children: "turbo"
    }), " with Rust"]
  })
}, {
  depth: 2,
  url: "#group-logs-for-improved-readability",
  title: _jsx(_Fragment, {
    children: "Group logs for improved readability"
  })
}, {
  depth: 2,
  url: "#updated-examples",
  title: _jsx(_Fragment, {
    children: "Updated examples"
  })
}, {
  depth: 2,
  url: "#community",
  title: _jsx(_Fragment, {
    children: "Community"
  })
}];
function _createMdxContent(props) {
  const _components = {
    a: "a",
    code: "code",
    em: "em",
    h2: "h2",
    li: "li",
    p: "p",
    pre: "pre",
    span: "span",
    strong: "strong",
    ul: "ul",
    ...props.components
  };
  return _jsxs(_Fragment, {
    children: [_jsx("h1", {
      className: "text-center",
      children: "Turborepo 1.11"
    }), "\n", "\n", _jsx(Date, {
      children: "Tuesday, December 5th, 2023"
    }), "\n", _jsx(Authors, {
      authors: ['gregsoltis', 'chrisolszewski', 'nicholasyang', 'alexanderlyon']
    }), "\n", _jsx(_components.p, {
      children: "Turborepo 1.11 completes our migration to Rust and ships several developer experience improvements:"
    }), "\n", _jsxs(_components.ul, {
      children: ["\n", _jsxs(_components.li, {
        children: [_jsx(_components.a, {
          href: "#unlocking-the-future-of-turbo-with-rust",
          children: _jsx(_components.strong, {
            children: "Our new Rust-based foundation"
          })
        }), ": We've finished the port from Go to lay the groundwork for better performance, improved stability, and new features."]
      }), "\n", _jsxs(_components.li, {
        children: [_jsx(_components.a, {
          href: "#group-logs-for-improved-readability",
          children: _jsx(_components.strong, {
            children: "Group logs for improved readability"
          })
        }), ": You can now specify ", _jsx(_components.code, {
          children: "--log-order=grouped"
        }), " to organize your logs into distinct sections separated by tasks."]
      }), "\n", _jsxs(_components.li, {
        children: [_jsx(_components.a, {
          href: "#updated-examples",
          children: _jsx(_components.strong, {
            children: "Updated examples"
          })
        }), ": Start with an example for Next.js, Svelte, Remix, Nuxt, and more."]
      }), "\n"]
    }), "\n", _jsxs(_components.p, {
      children: ["Update today by running ", _jsx(_components.code, {
        children: "npx @turbo/codemod migrate"
      }), "."]
    }), "\n", _jsxs(_components.h2, {
      id: "unlocking-the-future-of-turbo-with-rust",
      children: ["Unlocking the future of ", _jsx(_components.code, {
        children: "turbo"
      }), " with Rust"]
    }), "\n", _jsxs(_components.p, {
      children: ["As we wrote about in ", _jsx(_components.a, {
        href: "https://vercel.com/blog/turborepo-migration-go-rust",
        children: "our blog post about the migration"
      }), ", we're excited to start seeing the benefits of our porting effort for Turborepo users. Rust has allowed us to surface more complexity in ", _jsx(_components.em, {
        children: "our"
      }), " code so we're able to create a better experience in ", _jsx(_components.em, {
        children: "your"
      }), " codebase in several ways:"]
    }), "\n", _jsxs(_components.ul, {
      children: ["\n", _jsxs(_components.li, {
        children: ["We've noticed a slight performance improvement right away for some use cases, even without doing much performance tuning in our code yet. We look forward to diving deeper into making ", _jsx(_components.code, {
          children: "turbo"
        }), " ", _jsx(_components.strong, {
          children: "even faster soon"
        }), "."]
      }), "\n", _jsxs(_components.li, {
        children: ["We were able to move incidental behaviors of globbing, paths, and encoding support to tested and supported behavior, giving us better confidence that we're handling your configuration as expected. Going forward, we'll be able to build features like validation and automatic bug-fixing codemods into Turborepo for ", _jsx(_components.strong, {
          children: "better stability"
        }), "."]
      }), "\n", _jsxs(_components.li, {
        children: ["We've quickly iterated on ", _jsx(_components.strong, {
          children: "enhancing error messages"
        }), " in your monorepo as a feature for next release, giving you critical information for find the source of misconfigurations."]
      }), "\n", _jsxs(_components.li, {
        children: ["We've been able to catch possible platform-related bugs much sooner, as Rust forces us to think about the differences between platforms and environments much more closely than Go. This ", _jsx(_components.strong, {
          children: "deepened reliability"
        }), " removes an entire category of possible bugs from your repository."]
      }), "\n"]
    }), "\n", _jsxs(_components.p, {
      children: ["If you find any problems that you believe are related to the new Rust codepath, you can opt back to the Go codepath using the ", _jsx(_components.code, {
        children: "--go-fallback"
      }), " flag and ", _jsx(_components.a, {
        href: "https://github.com/vercel/turbo/issues/new?assignees=&labels=kind%3A+bug%2Cowned-by%3A+turborepo%2Cneeds%3A+triage&projects=&template=0-turborepo-bug-report.yml&title=%5Bturborepo%5D+",
        children: "report an issue on GitHub"
      }), "."]
    }), "\n", _jsx(_components.h2, {
      id: "group-logs-for-improved-readability",
      children: "Group logs for improved readability"
    }), "\n", _jsxs(_components.p, {
      children: ["To make it easier to review your task logs, we've introduced the ", _jsx(_components.code, {
        children: "--log-order"
      }), " flag to output all logs from a task ", _jsx(_components.strong, {
        children: "after it finishes"
      }), " rather than ", _jsx(_components.em, {
        children: "as it writes"
      }), ". This results in logs that are separated per-task, improving readability on a specific task's logs."]
    }), "\n", _jsx(ThemeAwareImage, {
      className: "my-4 flex justify-center",
      light: {
        alt: 'Using `--log-order=grouped` to output task logs to the terminal as separated chunks separated by task.',
        src: '/images/blog/turbo-1-11-0/log-order-groups-light.png',
        props: {
          width: 682,
          height: 746.5,
          className: 'dark:hidden block rounded-xl'
        }
      },
      dark: {
        alt: 'Using `--log-order=grouped` to output task logs to the terminal as separated chunks separated by task.',
        src: '/images/blog/turbo-1-11-0/log-order-groups-dark.png',
        props: {
          width: 682,
          height: 746.5,
          className: 'hidden dark:block rounded-xl'
        }
      }
    }), "\n", _jsxs(_components.p, {
      children: ["Enable this behavior using ", _jsx(_components.code, {
        children: "--log-order=grouped"
      }), ". ", _jsx(_components.a, {
        href: "/docs/reference/run#--log-order-option",
        children: "Check out the documentation"
      }), " to learn more"]
    }), "\n", _jsx(_components.h2, {
      id: "updated-examples",
      children: "Updated examples"
    }), "\n", _jsxs(_components.p, {
      children: ["Our repository contains ", _jsx(_components.a, {
        href: "https://github.com/vercel/turbo/tree/main/examples",
        children: _jsx(_components.code, {
          children: "an examples directory"
        })
      }), " with starter monorepos for your projects."]
    }), "\n", _jsx(_components.p, {
      children: "To get started with an example, run:"
    }), "\n", _jsx(_Fragment, {
      children: _jsx(_components.pre, {
        className: "shiki shiki-themes css-variables css-variables",
        style: {
          "--shiki-light": "var(--shiki-foreground)",
          "--shiki-dark": "var(--shiki-foreground)",
          "--shiki-light-bg": "var(--shiki-background)",
          "--shiki-dark-bg": "var(--shiki-background)"
        },
        tabIndex: "0",
        title: "Terminal",
        icon: "<svg viewBox=\"0 0 24 24\"><path d=\"m 4,4 a 1,1 0 0 0 -0.7070312,0.2929687 1,1 0 0 0 0,1.4140625 L 8.5859375,11 3.2929688,16.292969 a 1,1 0 0 0 0,1.414062 1,1 0 0 0 1.4140624,0 l 5.9999998,-6 a 1.0001,1.0001 0 0 0 0,-1.414062 L 4.7070312,4.2929687 A 1,1 0 0 0 4,4 Z m 8,14 a 1,1 0 0 0 -1,1 1,1 0 0 0 1,1 h 8 a 1,1 0 0 0 1,-1 1,1 0 0 0 -1,-1 z\" fill=\"currentColor\" /></svg>",
        children: _jsxs(_components.code, {
          children: [_jsx(_components.span, {
            className: "line",
            children: _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-comment)",
                "--shiki-dark": "var(--shiki-token-comment)"
              },
              children: "# Two Next.js applications"
            })
          }), "\n", _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-function)",
                "--shiki-dark": "var(--shiki-token-function)"
              },
              children: "npx"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-string)",
                "--shiki-dark": "var(--shiki-token-string)"
              },
              children: " create-turbo@latest"
            })]
          })]
        })
      })
    }), "\n", _jsx(_Fragment, {
      children: _jsx(_components.pre, {
        className: "shiki shiki-themes css-variables css-variables",
        style: {
          "--shiki-light": "var(--shiki-foreground)",
          "--shiki-dark": "var(--shiki-foreground)",
          "--shiki-light-bg": "var(--shiki-background)",
          "--shiki-dark-bg": "var(--shiki-background)"
        },
        tabIndex: "0",
        title: "Terminal",
        icon: "<svg viewBox=\"0 0 24 24\"><path d=\"m 4,4 a 1,1 0 0 0 -0.7070312,0.2929687 1,1 0 0 0 0,1.4140625 L 8.5859375,11 3.2929688,16.292969 a 1,1 0 0 0 0,1.414062 1,1 0 0 0 1.4140624,0 l 5.9999998,-6 a 1.0001,1.0001 0 0 0 0,-1.414062 L 4.7070312,4.2929687 A 1,1 0 0 0 4,4 Z m 8,14 a 1,1 0 0 0 -1,1 1,1 0 0 0 1,1 h 8 a 1,1 0 0 0 1,-1 1,1 0 0 0 -1,-1 z\" fill=\"currentColor\" /></svg>",
        children: _jsxs(_components.code, {
          children: [_jsx(_components.span, {
            className: "line",
            children: _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-comment)",
                "--shiki-dark": "var(--shiki-token-comment)"
              },
              children: "# Next.js and Remix"
            })
          }), "\n", _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-function)",
                "--shiki-dark": "var(--shiki-token-function)"
              },
              children: "npx"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-string)",
                "--shiki-dark": "var(--shiki-token-string)"
              },
              children: " create-turbo@latest"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-string)",
                "--shiki-dark": "var(--shiki-token-string)"
              },
              children: " -e"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-string)",
                "--shiki-dark": "var(--shiki-token-string)"
              },
              children: " kitchen-sink"
            })]
          })]
        })
      })
    }), "\n", _jsx(_Fragment, {
      children: _jsx(_components.pre, {
        className: "shiki shiki-themes css-variables css-variables",
        style: {
          "--shiki-light": "var(--shiki-foreground)",
          "--shiki-dark": "var(--shiki-foreground)",
          "--shiki-light-bg": "var(--shiki-background)",
          "--shiki-dark-bg": "var(--shiki-background)"
        },
        tabIndex: "0",
        title: "Terminal",
        icon: "<svg viewBox=\"0 0 24 24\"><path d=\"m 4,4 a 1,1 0 0 0 -0.7070312,0.2929687 1,1 0 0 0 0,1.4140625 L 8.5859375,11 3.2929688,16.292969 a 1,1 0 0 0 0,1.414062 1,1 0 0 0 1.4140624,0 l 5.9999998,-6 a 1.0001,1.0001 0 0 0 0,-1.414062 L 4.7070312,4.2929687 A 1,1 0 0 0 4,4 Z m 8,14 a 1,1 0 0 0 -1,1 1,1 0 0 0 1,1 h 8 a 1,1 0 0 0 1,-1 1,1 0 0 0 -1,-1 z\" fill=\"currentColor\" /></svg>",
        children: _jsxs(_components.code, {
          children: [_jsx(_components.span, {
            className: "line",
            children: _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-comment)",
                "--shiki-dark": "var(--shiki-token-comment)"
              },
              children: "# Vue and Nuxt"
            })
          }), "\n", _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-function)",
                "--shiki-dark": "var(--shiki-token-function)"
              },
              children: "npx"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-string)",
                "--shiki-dark": "var(--shiki-token-string)"
              },
              children: " create-turbo@latest"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-string)",
                "--shiki-dark": "var(--shiki-token-string)"
              },
              children: " -e"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-string)",
                "--shiki-dark": "var(--shiki-token-string)"
              },
              children: " with-vue-nuxt"
            })]
          })]
        })
      })
    }), "\n", _jsx(_components.p, {
      children: "We're putting a renewed effort towards ensuring our examples are kept up-to-date. Additionally, we've re-architected our examples to advocate for best practices in monorepos. For example:"
    }), "\n", _jsxs(_components.ul, {
      children: ["\n", _jsx(_components.li, {
        children: "In-editor go-to-definition across packages"
      }), "\n", _jsx(_components.li, {
        children: "Dependencies updated to latest versions"
      }), "\n", _jsx(_components.li, {
        children: "Tooling like ESLint, Prettier, jest, and vitest pre-configured"
      }), "\n", _jsx(_components.li, {
        children: "Hot-reloading across packages"
      }), "\n"]
    }), "\n", _jsxs(_components.p, {
      children: [_jsx(_components.a, {
        href: "/docs/getting-started/examples",
        children: "Use an example"
      }), " to get started, or ", _jsx(_components.a, {
        href: "https://github.com/vercel/turbo/tree/main/examples",
        children: "browse the code directly"
      }), " for more."]
    }), "\n", _jsx(_components.h2, {
      id: "community",
      children: "Community"
    }), "\n", _jsxs(_components.p, {
      children: ["Since releasing ", _jsx(_components.a, {
        href: "/blog/turbo-1-10-0",
        children: "Turborepo 1.10"
      }), " we've seen incredible adoption and community growth:"]
    }), "\n", _jsxs(_components.ul, {
      children: ["\n", _jsx(_components.li, {
        children: _jsx(_components.a, {
          href: "https://github.com/vercel/turbo",
          children: "23.6k+ GitHub Stars"
        })
      }), "\n", _jsx(_components.li, {
        children: _jsx(_components.a, {
          href: "https://www.npmjs.com/package/turbo",
          children: "1.8M+ weekly NPM downloads"
        })
      }), "\n", _jsxs(_components.li, {
        children: ["206 years of compute time saved through ", _jsx(_components.a, {
          href: "https://vercel.com/docs/concepts/monorepos/remote-caching",
          children: "Remote Caching on Vercel"
        })]
      }), "\n"]
    }), "\n", _jsx(_components.p, {
      children: "Turborepo is the result of the combined work of all of its contributors, including our core team."
    }), "\n", _jsx(_components.p, {
      children: "Thank you for your continued support, feedback, and collaboration to make Turborepo your build tool of choice."
    })]
  });
}
export default function MDXContent(props = {}) {
  const {wrapper: MDXLayout} = props.components || ({});
  return MDXLayout ? _jsx(MDXLayout, {
    ...props,
    children: _jsx(_createMdxContent, {
      ...props
    })
  }) : _createMdxContent(props);
}
